import { render, staticRenderFns } from "./acciones-correctivas-preventivas-editar.vue?vue&type=template&id=bbfffd94&scoped=true&"
import script from "./acciones-correctivas-preventivas-editar.vue?vue&type=script&lang=js&"
export * from "./acciones-correctivas-preventivas-editar.vue?vue&type=script&lang=js&"
import style0 from "./acciones-correctivas-preventivas-editar.vue?vue&type=style&index=0&id=bbfffd94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfffd94",
  null
  
)

export default component.exports